module.exports = __webpack_public_path__ + "static/media/poweroff.6d4be066.png";